module.exports = __webpack_public_path__ + "static/media/RealEstate.ef83c41c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Industries/RealEstate.svg
// module id = 322
// module chunks = 0